import { API_BASE_URL } from './constants';
import {
  clearStoredSession,
  REFRESH_TOKEN_KEY,
  saveStoredSession,
  TOKEN_KEY,
} from './session';

async function readResponse(response) {
  const text = await response.text();

  if (!text) {
    return null;
  }

  try {
    return JSON.parse(text);
  } catch (_) {
    return text;
  }
}

async function refreshSession() {
  const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY) || '';

  if (!refreshToken) {
    return false;
  }

  try {
    const response = await fetch(`${API_BASE_URL}/refresh`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ refresh_token: refreshToken }),
    });

    const data = await readResponse(response);

    if (!response.ok || !data || typeof data !== 'object') {
      return false;
    }

    const nextToken = data.token || '';
    const nextRefreshToken = data.refresh_token || '';
    const user = data.user || null;

    if (!nextToken || !nextRefreshToken) {
      return false;
    }

    saveStoredSession({
      token: nextToken,
      refreshToken: nextRefreshToken,
      user,
    });

    return true;
  } catch (_) {
    return false;
  }
}

async function apiRequest(path, options = {}) {
  const { method = 'GET', body, auth = true } = options;
  const headers = {
    'Content-Type': 'application/json',
  };

  if (auth) {
    const token = localStorage.getItem(TOKEN_KEY) || '';
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
  }

  const execute = async () => {
    const response = await fetch(`${API_BASE_URL}${path}`, {
      method,
      headers,
      body: body === undefined ? undefined : JSON.stringify(body),
    });
    const data = await readResponse(response);
    return { response, data };
  };

  let result = await execute();

  if (auth && result.response.status === 401) {
    const refreshed = await refreshSession();

    if (refreshed) {
      const nextToken = localStorage.getItem(TOKEN_KEY) || '';
      if (nextToken) {
        headers.Authorization = `Bearer ${nextToken}`;
      } else {
        delete headers.Authorization;
      }
      result = await execute();
    }
  }

  if (!result.response.ok) {
    if (auth && result.response.status === 401) {
      clearStoredSession();
    }

    const errorMessage =
      (result.data &&
        typeof result.data === 'object' &&
        (result.data.error || result.data.message)) ||
      'Request failed';

    throw new Error(errorMessage);
  }

  return result.data;
}

export { apiRequest };